import { ErrorBase } from '../shared/errors';

export enum CartErrorTypeEnum {
  CampaignDataFail = 'CAMPAIGN_DATA',
  CartConflict = 'CART_CONFLICT',
  CartGeneric = 'CART_GENERIC',
  CartEmpty = 'CART_EMPTY',
  CartMaxExceeded = 'CART_MAX',
  CartMergeLoser = 'CART_MERGE_LOSS',
  CartSave = 'CART_SAVE',
  ChildNotFound = 'CHILD_NOT_FOUND',
  ChildNotFoundMulti = 'CHILD_NOT_FOUND_MULTI',
  GiftConflictBirthday = 'GIFT_CONFLICT_BIRTHDAY',
  GiftConflictChild = 'GIFT_CONFLICT_CHILD',
  GiftUnavailable = 'GIFT_UNAVAIL',
  HoldConvertFailed = 'HOLD_CONVERT',
  HoldFailed = 'HOLD_FAILED',
  HoldExtendFailed = 'HOLD_EXTEND_FAILED',
  HoldMultiFailed = 'HOLD_MULTI_FAILED',
  HoldLost = 'HOLD_LOST',
  HoldSponsored = 'HOLD_SPONSORED',
  HoldSponsoredUpsell = 'HOLD_SPONSORED_UPSELL',
  // HoldFail = 'HOLD_FAIL',
  InactiveFund = 'INACTIVE_FUND',
  IncompleteFundData = 'INCOMPLETE_FUND_DATA',
  ItemAmountRange = 'ITEM_RANGE',
  ItemExists = 'ITEM_EXISTS',
  ItemMaxExceeded = 'ITEM_MAX',
  ItemMinSubceeded = 'ITEM_MIN',
  ItemNotFound = 'ITEM_NOT_FOUND',
  ItemUnavaliableFreq = 'ITEM_FREQ',
  ItemsAdd = 'ITEMS_ADD',
  // ItemRemove = 'ITEM_REMOVE',
  // ItemUpdate = 'ITEM_UPDATE',
  // InvalidAmount = 'ITEM_AMOUNT',
  PremiumFail = 'PREMIUM',
}

// TODO: These interfaces aren't really being used...

/**
 * NOTE: we can build out additional errors for specific scenarios by
 * extending this pattern. The following error is just a super generic
 * (very unhelpful) catchall. Honestly, we probably shouldn't even be
 * using it, but it may be helpful for scaffolding errors out.
 */
export type ErrorCartGeneric = ErrorBase;

export interface HoldLostBase {
  childPronoun: 'him' | 'her' | 'them';
  /**
   * Optional for internal logging
   */
  holdIds?: string[];
}
export interface SingleHoldLost extends HoldLostBase {
  childName: string;
  childNames?: never;
}
export interface MultipleHoldsLost extends HoldLostBase {
  childName?: never;
  childNames: string | null;
}

export interface ErrorCartHoldLost extends ErrorBase {
  type: CartErrorTypeEnum.HoldLost;
  data: SingleHoldLost | MultipleHoldsLost;
}

export interface ErrorCartHoldSponsored extends ErrorBase {
  type: CartErrorTypeEnum.HoldLost;
  data: {
    childName?: string;
  };
}

export interface ErrorCartSave extends ErrorBase {
  type: CartErrorTypeEnum.CartSave;
  cartId: string;
  supporterId?: string;
}

export interface ErrorCartItemExists extends ErrorBase {
  type: CartErrorTypeEnum.ItemExists;
  data?: {
    // TODO: Not currently used - using `CartItemPayload` here bloats the cartResponseDTO.json...
    // item: CartItem;
    /**
     * Optional for internal logging
     */
    cartId?: string;
  };
}

export interface ErrorCartMax extends ErrorBase {
  type: CartErrorTypeEnum.CartMaxExceeded;
  data?: {
    /**
     * Optional for internal logging
     */
    total?: number;
    maxLimit: number;
    /**
     * Optional for internal logging
     */
    cartId?: string;
  };
}

export interface ErrorCartItemMax extends ErrorBase {
  type: CartErrorTypeEnum.ItemMaxExceeded;
  data?: {
    /**
     * Optional for internal logging
     */
    amount?: number;
    maxLimit: number;
    /**
     * Optional for internal logging
     */
    cartItemId?: string;
  };
}

export interface ErrorCartItemRange extends ErrorBase {
  type: CartErrorTypeEnum.ItemAmountRange;
  data?: {
    /**
     * Optional for internal logging
     */
    amount?: number;
    min: number;
    max: number;
    /**
     * Optional for internal logging
     */
    cartItemId?: string;
  };
}

export type ErrorCart =
  | ErrorCartGeneric
  | ErrorCartHoldLost
  | ErrorCartHoldSponsored
  | ErrorCartMax
  | ErrorCartSave
  | ErrorCartItemExists
  | ErrorCartItemMax
  | ErrorCartItemRange;
